.button {
  display: inline-flex; align-items: center; justify-content: center; gap: var(--space-2);
  border: 1px solid transparent; border-radius: var(--radius-sm);
  font-weight: var(--weight-medium); white-space: nowrap; user-select: none;
  transition: background-color var(--duration-fast) ease, border-color var(--duration-fast) ease,
    color var(--duration-fast) ease, transform var(--duration-instant) var(--ease-out);
}
.button:active:not(:disabled) { transform: scale(0.97); }
.button:disabled { cursor: not-allowed; opacity: 0.5; }
.md { height: 36px; padding: 0 var(--space-4); font-size: var(--text-md); }
.sm { height: 30px; padding: 0 var(--space-3); font-size: var(--text-sm); }
.button svg { width: 18px; height: 18px; flex: none; }
.sm svg { width: 16px; height: 16px; }

.primary { background: var(--color-primary); color: var(--color-text-on-primary); }
.primary:hover:not(:disabled) { background: var(--color-primary-hover); }
.primary:active:not(:disabled) { background: var(--color-primary-active); }

.secondary { background: var(--color-surface); border-color: var(--color-border-strong); color: var(--color-text); }
.secondary:hover:not(:disabled) { background: var(--color-surface-hover); }

.ghost { background: transparent; color: var(--color-text-secondary); }
.ghost:hover:not(:disabled) { background: var(--color-surface-hover); color: var(--color-text); }

.danger { background: var(--color-danger); color: #fff; }
.danger:hover:not(:disabled) { background: color-mix(in oklab, var(--color-danger) 88%, black); }

.loading { cursor: progress; }
.loading:disabled { opacity: 0.8; }
.spinner {
  width: 14px; height: 14px; border-radius: var(--radius-full);
  border: 2px solid currentColor; border-right-color: transparent;
  animation: spin 600ms linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .spinner { animation-duration: 1.6s; } }
